import type { SeriesBySensor, TelemetryMeasure } from '@/apis/telemetry';

/** Joins time-ordered chunks into one series per sensor and measure, dropping any reading not after the last kept one. */
export const stitchSeries = (
  chunks: readonly SeriesBySensor[]
): SeriesBySensor => {
  const merged: SeriesBySensor = {};
  for (const chunk of chunks) {
    for (const [sensorId, measures] of Object.entries(chunk)) {
      const target = (merged[sensorId] ??= {});
      for (const name of Object.keys(measures) as TelemetryMeasure[]) {
        const incoming = measures[name];
        if (!incoming) continue;
        const series = (target[name] ??= { t: [], v: [] });
        let last = series.t.length ? series.t[series.t.length - 1] : -Infinity;
        for (let i = 0; i < incoming.t.length; i += 1) {
          if (incoming.t[i] > last) {
            series.t.push(incoming.t[i]);
            series.v.push(incoming.v[i]);
            last = incoming.t[i];
          }
        }
      }
    }
  }
  return merged;
};
